var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.programStyle, 'flex-row']},[_vm._m(0),_c('div',{staticClass:"table-right flex-row"},_vm._l((_vm.columnData),function(column){return _c('table',{key:column.period},[_c('tr',[_c('td',[_vm._v(_vm._s(column.period))])]),_c('tr',{class:{
          'no-si': column.mostSevereInfractionType === 'No SI',
          grace: column.mostSevereInfractionType === 'Grace',
          'follow-up': column.mostSevereInfractionType === 'Follow Up',
          'first-warning':
            column.mostSevereInfractionType === '1st Warn' ||
            column.mostSevereInfractionType === 'First' ||
            column.mostSevereInfractionType === '1',
          probation: column.mostSevereInfractionType === 'Probation',
          'penalty-and-probation':
            column.mostSevereInfractionType === 'Penalty & Probation' ||
            column.mostSevereInfractionType === 'Penalty',
          'second-warning':
            column.mostSevereInfractionType === '2nd Warn' ||
            column.mostSevereInfractionType === 'Second' ||
            column.mostSevereInfractionType === '2',
          'third-warning':
            column.mostSevereInfractionType === '3rd Warn' ||
            column.mostSevereInfractionType === 'Third' ||
            column.mostSevereInfractionType === '3',
          'fourth-warning':
            column.mostSevereInfractionType === '4th Warn' ||
            column.mostSevereInfractionType === 'Fourth' ||
            column.mostSevereInfractionType === '4',
          'fifth-warning':
            column.mostSevereInfractionType === '5th Warn' ||
            column.mostSevereInfractionType === 'Fifth' ||
            column.mostSevereInfractionType === '5',
          'sixth-warning':
            column.mostSevereInfractionType === '6th Warn' ||
            column.mostSevereInfractionType === 'Sixth' ||
            column.mostSevereInfractionType === '6',
          'seventh-warning':
            column.mostSevereInfractionType === '7th Warn' ||
            column.mostSevereInfractionType === 'Seventh' ||
            column.mostSevereInfractionType === '7',
          'eighth-warning':
            column.mostSevereInfractionType === '8th Warn' ||
            column.mostSevereInfractionType === 'Eighth' ||
            column.mostSevereInfractionType === '8',
          'ninth-warning':
            column.mostSevereInfractionType === '9th Warn' ||
            column.mostSevereInfractionType === 'Ninth' ||
            column.mostSevereInfractionType === '9',
          'tenth-warning':
            column.mostSevereInfractionType === '10th Warn' ||
            column.mostSevereInfractionType === 'Tenth' ||
            column.mostSevereInfractionType === '10',
          'tenthplus-warning':
            column.mostSevereInfractionType === '10th+ Warn' ||
            column.mostSevereInfractionType === 'Tenth+' ||
            column.mostSevereInfractionType === '10+',
        }},[_c('td',[_vm._v(" "+_vm._s(column.mostSevereInfractionType)+" ")])]),_c('tr',[_c('td',[_vm._v(_vm._s(column.interferenceCount))])]),_c('tr',[_c('td',[_vm._v(_vm._s(column.removalCount))])])])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-left"},[_c('table',[_c('tr',[_c('td',[_vm._v("Month:")])]),_c('tr',[_c('td',[_vm._v("Status:")])]),_c('tr',[_c('td',[_vm._v("Interference:")])]),_c('tr',[_c('td',[_vm._v("Removal:")])])])])}]

export { render, staticRenderFns }